import { ProgressTypeEnum } from '../../enums/progress-type/progress-type.enum';
import { ProgressDone } from './progress-done.model';

export const progressDone: ProgressDone<'foo'> = {
    type: ProgressTypeEnum.DONE,
    data: 'foo',
};
